(function () {
    "use strict";

    angular.module("app").component("habilPayrollConsultantView", {
        templateUrl: '@/ivm/payrollConsultant/payroll-consultant-view.template.html',
        bindings: {
            request: '=',
        },
        controller: PayrollConsultant
    });

    PayrollConsultant.$inject = ["enumService",];
    function PayrollConsultant(enumService,) {
        const AttachmentTypes = enumService.AttachmentTypes;
        const protectedAttachmentTypes = [AttachmentTypes.EmploymentContract, AttachmentTypes.ExclusivityDocument];

        const $controller = Object.assign(this, {
            AttachmentTypes,
            GetConsultantAttachments,
        });

        function GetConsultantAttachments() {
            if (!$controller.request)
                return [];

            return $controller.request.Attachments.filter(a => protectedAttachmentTypes.includes(Number.parseInt(a.TypeCode)));
        }
    }
})();